<template>
  <div class="modal-body-content">
    <div class="modal-body-list-box">
      <div class="search-box-in-title" style="align-items: center;">
        <h2>{{ $t('entry_exit') }} {{ $t('list') }}</h2>
        <h3 style="display: flex; gap: 5px; margin: 0; align-items: end; font-size: 16px; text-align: right; color: gray;" :style="getIsMobile() ? { fontSize: '12px', flexDirection: 'column' } : {}">
          <div>
            <div style="display: flex; gap: 5px;" v-show="!getIsMobile()">
              {{ $t('total') }} <span style="color: black;">{{ event_list.length }}</span> {{ $t('cases') }} | 
            </div>
          </div>
          <div style="display: flex; gap: 5px;">
            <img src="@/assets/images/warning.svg"/>
            <img src="@/assets/images/enter.svg"/> <span>{{ countWarningEnter }}</span> 건, 
            <img src="@/assets/images/exit.svg"/> <span>{{ countWarningExit }}</span> 건
          </div>
          <div style="margin-bottom: 2px;" v-show="!getIsMobile()">|</div>
          <div style="display: flex; gap: 5px;">
            <img src="@/assets/images/info.svg"/>
            <img src="@/assets/images/enter.svg"/> <span>{{ countInfoEnter }}</span> 건, 
            <img src="@/assets/images/exit.svg"/> <span>{{ countInfoExit }}</span> 건
          </div>
        </h3>
      </div>
      <div style="display: flex; width: 100%; padding: 0 48px;" :style="getIsMobile() ? { padding: '0 5px' } : {}">
        <div style="display: flex; gap: 10px; width: 100%;" :style="getIsMobile() ? { gap: '3px', overflowX: 'auto', flexDirection: 'column' } : {}">
          <div style="display: flex; gap: 10px; align-items: center;" :style="getIsMobile() ? { width: '100%', justifyContent: 'space-between' } : {}">
            <input
              id="startFilter"
              type="datetime-local"
              v-model="startDate"
              :max="endDate"
              style="width: 230px;"
              :style="getIsMobile() ? { fontSize: '11px', width: '160px' } : {}"
            />
            ~
            <input
              id="endFilter"
              type="datetime-local"
              v-model="endDate"
              :min="startDate"
              :max="ConvertDateTimeString(now, 'YYYY-MM-DDTHH:MM')"
              style="width: 230px;"
              :style="getIsMobile() ? { fontSize: '11px', width: '160px' } : {}"
            />
          </div>
          <div style="display: flex; gap: 10px; align-items: center; width: 100%;" :style="getIsMobile() ? { justifyContent: 'space-between' } : {}">
            <select v-model="selectedEventType" style="width: 100px;" :style="getIsMobile() ? { width: '160px', fontSize: '11px' } : {}">
              <option value="">{{ $t('all') }}</option>
              <option value="info">{{ $t('info') }}</option>
              <option value="warning">{{ $t('warn') }}</option>
            </select>
            <input v-model="search" :placeholder="$t('insert_search_query')" style="flex: 1; min-width: 200px; max-width: 320px;" :style="getIsMobile() ? { fontSize: '11px', width: '160px' } : {}" />
          </div>
        </div>
        <div class="button-group" style="width: 139px; min-width: 116px;" v-show="!getIsMobile()">
          <button class="white-button" @click="exportToExcel_EER(filteredActiveList, startDate, endDate)" style="display: flex; gap: 5px;">
            {{ $t('excel_download') }}
            <img src="@/assets/images/download_blue.svg"/>
          </button>
        </div>
      </div>
      <div style="display: flex; height: calc(100% - 167px); gap: 20px; padding: 0 48px; padding-bottom: 24px;"  :style="getIsMobile() ? { flexDirection: 'column', padding: 0, height: 'calc(100% - 115px)' } : {}">
        <div v-if="getIsMobile()" style="display: flex; flex-direction: column; gap: 24px; align-items: center; width: 50%;" :style="{ width: '100%' }">
          <table :style="{ padding: '0 5px', height: '300px' }">
            <thead>
              <tr>
                <th class="w20p" @click="toggleSort('enter_exit_records', 'event_time')" :style="{ fontSize: '12px' }">
                  {{ $t('date') }}
                  <span v-if="sortStates.enter_exit_records.find(col => col.id === 'event_time').order">
                    <img v-if="sortStates.enter_exit_records.find(col => col.id === 'event_time').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                    <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
                  </span>
                  <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
                </th>
                <th class="w20p" @click="toggleSort('enter_exit_records', 'device_name')" :style="{ fontSize: '12px' }">
                  {{ $t('device') }} {{ $t('name') }}
                  <span v-if="sortStates.enter_exit_records.find(col => col.id === 'device_name').order">
                    <img v-if="sortStates.enter_exit_records.find(col => col.id === 'device_name').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                    <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
                  </span>
                  <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
                </th>
                <th class="w10p" @click="toggleSort('enter_exit_records', 'action')" :style="{ fontSize: '12px' }">
                  {{ $t('entry_exit') }}
                  <span v-if="sortStates.enter_exit_records.find(col => col.id === 'action').order">
                    <img v-if="sortStates.enter_exit_records.find(col => col.id === 'action').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                    <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
                  </span>
                  <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="log in paginatedData" :key="log.event_id" @click="showPath(log);" style="cursor: pointer;" :style="selectedEventId === log.event_id ? { backgroundColor: '#00FF0040' } : (getIsMobile() && log.state === 1) ? { backgroundColor: '#FFFF0060' } : {}">
                <td :title="log.event_time" class="w20p" :style="{ fontSize: '12px' }">
                  {{ log.event_time }}
                </td>
                <td :title="log.device_name" class="w20p" :style="{ fontSize: '12px' }">
                  {{ log.device_name }}
                </td>
                <td :title="log.action" class="w10p">
                  <span style="display: flex; align-items: center; justify-content: center; gap: 3px; border-radius: 8px; width: 60px; padding: 3px; font-size: 12px; font-weight: bold;" :style="log.action === 'exit' ? { border: '1px solid #f56258' } : { border: '1px solid #467AEB' }">
                    <img :src="enterExitImage(log.action)" style="margin-top: 1px; padding: 0;" />
                    {{ $t(log.action) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- 페이지네이션 -->
          <div class="pagination-control" style="padding: 0;">
            <div>
              <img src="@/assets/images/double_arrow_left_gray.svg" @click.stop="prevPagePer" v-show="currentPage !== 1"/>
              <img src="@/assets/images/arrow_left_gray.svg" @click.stop="prevPage" v-show="currentPage !== 1"/>
            </div>
            <span v-for="page in currentPageRange" :key="page" @click.stop="currentPage = page" :class="{ selected: currentPage === page }">{{ page }}</span>
            <div>
              <img src="@/assets/images/arrow_right_gray.svg" @click.stop="nextPage" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
            <img src="@/assets/images/double_arrow_right_gray.svg" @click.stop="nextPagePer" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
            </div>
          </div>
        </div>

        <div id="pathMap" style="flex: 1; height: 100%;" :style="getIsMobile() ? { width: '100%' } : {}"></div>

        <div v-if="!getIsMobile()" style="display: flex; flex-direction: column; gap: 24px; align-items: center; width: 50%;">
          <table :style="{ padding: '0' }">
            <thead>
              <tr>
                <th class="w20p" @click="toggleSort('enter_exit_records', 'event_time')">
                  {{ $t('date') }}
                  <span v-if="sortStates.enter_exit_records.find(col => col.id === 'event_time').order">
                    <img v-if="sortStates.enter_exit_records.find(col => col.id === 'event_time').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                    <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
                  </span>
                  <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
                </th>
                <th class="w10p" @click="toggleSort('enter_exit_records', 'state')">
                  {{ $t('state') }}
                  <span v-if="sortStates.enter_exit_records.find(col => col.id === 'state').order">
                    <img v-if="sortStates.enter_exit_records.find(col => col.id === 'state').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                    <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
                  </span>
                  <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
                </th>
                <th class="w20p" @click="toggleSort('enter_exit_records', 'device_name')">
                  {{ $t('device') }} {{ $t('name') }}
                  <span v-if="sortStates.enter_exit_records.find(col => col.id === 'device_name').order">
                    <img v-if="sortStates.enter_exit_records.find(col => col.id === 'device_name').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                    <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
                  </span>
                  <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
                </th>
                <th class="w10p" @click="toggleSort('enter_exit_records', 'action')">
                  {{ $t('entry_exit') }}
                  <span v-if="sortStates.enter_exit_records.find(col => col.id === 'action').order">
                    <img v-if="sortStates.enter_exit_records.find(col => col.id === 'action').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                    <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
                  </span>
                  <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
                </th>
                <th class="w20p" @click="toggleSort('enter_exit_records', 'geofence_name')">
                  {{ $t('geofence') }}
                  <span v-if="sortStates.enter_exit_records.find(col => col.id === 'geofence_name').order">
                    <img v-if="sortStates.enter_exit_records.find(col => col.id === 'geofence_name').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                    <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
                  </span>
                  <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="log in paginatedData" :key="log.event_id" @click="showPath(log);" style="cursor: pointer;" :style="selectedEventId === log.event_id ? { backgroundColor: '#00FF0040' } : {}">
                <td :title="log.event_time" class="w20p">
                  {{ ConvertDateTimeString(new Date(log.event_time), "YYYY-MM-DD HH:MM:SS") }}
                </td>
                <td :title="eventType(log.state)" class="w10p">
                  <span style="align-items: center; border-radius: 8px; width: 60px; padding: 3px 7px; font-size: 12px; font-weight: bold;" :style="log.state === 1 ? { border: '1px solid #f56258' } : { border: '1px solid #467AEB' }">
                    <img :src="stateImage(log.state)" style="margin-bottom: -1px; padding: 0;" />
                    {{ log.state === 1 ? $t('warn') : $t('info') }}
                  </span>
                </td>
                <td :title="log.device_name" class="w20p">
                  {{ log.device_name }}
                </td>
                <td :title="log.action" class="w10p">
                  <span style="align-items: center; border-radius: 8px; width: 60px; padding: 3px 7px; font-size: 12px; font-weight: bold;" :style="log.action === 'exit' ? { border: '1px solid #f56258' } : { border: '1px solid #467AEB' }">
                    <img :src="enterExitImage(log.action)" style="margin-bottom: -1px; padding: 0;" />
                    {{ $t(log.action) }}
                  </span>
                </td>
                <td :title="log" class="w20p">
                  {{ log.geofence_name }}
                </td>
              </tr>
            </tbody>
          </table>
          <!-- 페이지네이션 -->
          <div class="pagination-control" style="padding: 0;">
            <div>
              <img src="@/assets/images/double_arrow_left_gray.svg" @click.stop="prevPagePer" v-show="currentPage !== 1"/>
              <img src="@/assets/images/arrow_left_gray.svg" @click.stop="prevPage" v-show="currentPage !== 1"/>
            </div>
            <span v-for="page in currentPageRange" :key="page" @click.stop="currentPage = page" :class="{ selected: currentPage === page }">{{ page }}</span>
            <div>
              <img src="@/assets/images/arrow_right_gray.svg" @click.stop="nextPage" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
            <img src="@/assets/images/double_arrow_right_gray.svg" @click.stop="nextPagePer" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import L from 'leaflet';
import "leaflet-polylinedecorator";
import { exportToExcel_EER } from "@/utils/ExcelExport";
import { ConvertDateTimeString, eventType, getEvnetKeyByValue, getIsMobile } from "@/utils/GlobalUtility";
import { loadingStore } from "@/utils/LoadingStore";
import { CalculateCircleBoundary, firstMapSetting } from "@/utils/MapSetting";
import { event_list, geofence_list, GET_SERVER_REQUEST } from "@/utils/ServerConnect";
import { sortedActiveEERList, sortStates, toggleSort } from "@/utils/SortUtility";

const pathMap = ref(null);
// 오늘 날짜를 max 속성으로 제공
const now = new Date();

// 필터
const selectedEventId = ref(null);
const selectedEventType = ref('');
const startDate = ref(ConvertDateTimeString(new Date(now.getTime() - 24 * 60 * 60 * 1000), 'YYYY-MM-DDTHH:MM'));
const endDate = ref(ConvertDateTimeString(new Date(now.getTime() + 60 * 1000), 'YYYY-MM-DDTHH:MM'));

onMounted(async () => {
  pathMap.value = await firstMapSetting('pathMap', 17); // 지도 생성
  geofence_list.value = await GET_SERVER_REQUEST('geofence');
  event_list.value = await GET_SERVER_REQUEST('event', createParam());
  setGeofenceName();

  loadingStore.hideLoading();
});

const setGeofenceName = () => {
  const mapGroup = new Map(geofence_list.value.map(geo => [geo.geofence_id, geo.geofence_name]));
  event_list.value = event_list.value.map(event => ({
    ...event,
    geofence_name: mapGroup.get(event.geofence_id) || null
  }));
}

// 선택된 데이터만 JSON으로 생성
const createParam = () => {
  let data = '/?';

  if (startDate.value) {
    data += 'starttime=' + startDate.value.replaceAll(':', '').replaceAll('-', '').replaceAll('T', '') + '&';
  }

  if (endDate.value) {
    data += 'endtime=' + endDate.value.replaceAll(':', '').replaceAll('-', '').replaceAll('T', '') + '&';
  }

  if (selectedEventType.value !== '') {
    data += 'state=' + getEvnetKeyByValue(selectedEventType.value) + '&';
  }

  return data;
};

const currentPage = ref(1);
const itemsPerPage = computed(() => { return (getIsMobile() ? 5 : 10) });
const showOncePage = computed(() => { return (getIsMobile() ? 5 : 10) });
// 페이지네이션된 데이터 계산
const totalPages = computed(() =>
  Math.ceil(filteredActiveList.value.length / itemsPerPage.value)
);
const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  return filteredActiveList.value.slice(start, start + itemsPerPage.value);
});
const minPageRange = computed(() => {
  if (currentPage.value % showOncePage.value === 0) return currentPage.value - (showOncePage.value - 1);
  else return currentPage.value - ((currentPage.value % showOncePage.value) - 1);
});
const maxPageRange = computed(() => {
  let num = minPageRange.value + (showOncePage.value - 1);
  if (num > totalPages.value) num = totalPages.value
  return num;
});
const currentPageRange = computed(() => {
  const range = []
  for (let i = minPageRange.value; i <= maxPageRange.value; i++) {
    range.push(i)
  }
  return range;
});
// 페이지네이션 함수
const prevPage = () => {
  if (currentPage.value > 1) currentPage.value--;
};
const prevPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  if (num < 1) currentPage.value = 1;
  else currentPage.value = ((num - 1) * showOncePage.value) + 1;
};
const nextPage = () => {
  if (currentPage.value < totalPages.value) currentPage.value++;
};
const nextPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  const check = ((num + 1) * showOncePage.value) + 1
  if (check > totalPages.value) currentPage.value = totalPages.value;
  else currentPage.value = check;
};

watch([startDate, endDate, selectedEventType], async () => {
  currentPage.value = 1; // 필터 변경 시 첫 페이지로 이동
  event_list.value = await GET_SERVER_REQUEST('event', createParam());
  setGeofenceName();
})

// 🖼️ 이미지 경로 반환
const enterExitImage = (action) => {
  if (!action) return new URL('../assets/images/lock.svg', import.meta.url).href;
  if (action === 'enter') return new URL('../assets/images/enter.svg', import.meta.url).href;
  if (action === 'exit') return new URL('../assets/images/exit.svg', import.meta.url).href;
  return new URL('../assets/images/lock.svg', import.meta.url).href;
};
const stateImage = (state) => {
  if (state === null) return new URL('../assets/images/lock.svg', import.meta.url).href;
  if (state === 0) return new URL('../assets/images/info.svg', import.meta.url).href;
  if (state === 1) return new URL('../assets/images/warning.svg', import.meta.url).href;
  return new URL('../assets/images/lock.svg', import.meta.url).href;
};

const countWarningEnter = computed(() => {
  return event_list.value.filter(log => log.state === 1 && log.action === 'enter').length;
})
const countWarningExit = computed(() => {
  return event_list.value.filter(log => log.state === 1 && log.action === 'exit').length;
})
const countInfoEnter = computed(() => {
  return event_list.value.filter(log => log.state === 0 && log.action === 'enter').length;
})
const countInfoExit = computed(() => {
  return event_list.value.filter(log => log.state === 0 && log.action === 'exit').length;
})

const showPath = (log) => {
  selectedEventId.value = log.event_id;
  // 해당되는 영역 그리기
  drawPolygon(geofence_list.value.find(geo => geo.geofence_id === log.geofence_id));
  // 이벤트 로그에 걸린 경로+방향 그리기
  drawPloyLine(log.before_location, log.after_location);
};
let polygonLayer = [];
// 폴리곤 생성 함수
const drawPolygon = (geofence) => {
  if (polygonLayer) polygonLayer.forEach(polygon => { pathMap.value.removeLayer(polygon); }); // 기존 폴리곤이 있다면 삭제
  polygonLayer = [];
  let bounds = L.latLngBounds();

  const latlngs = geofence.data.locations; // 남아있는 마커들의 좌표 가져오기
  if (latlngs.length > 2) {
    polygonLayer.push(L.polygon(latlngs, { color: 'blue', type: "polygon" }).addTo(pathMap.value));  // 3개 이상의 마커가 있을 때만 폴리곤을 그림
    bounds.extend(latlngs);
  }
  if (latlngs.length === 1) {
    const radius = geofence.type.substr(geofence.type.indexOf('#') + 1)
    polygonLayer.push(L.circle(latlngs[0], { radius: radius, color: 'blue', fillOpacity: 0.2, type: "polygon" }).addTo(pathMap.value)); // 1개 일경우 원
    bounds.extend(CalculateCircleBoundary(latlngs[0].lat, latlngs[0].lng, radius));
  }
};

let polylineLayer = [];
const drawPloyLine = (before_location, after_location) => {
  const start = { lat: before_location.latitude, lng: before_location.longitude };
  const end = { lat: after_location.latitude, lng: after_location.longitude };

  drawArrowByDistance(start, end);

  // const polyline = L.polyline([start, end], { color: "#00aa00", weight: 10, opacity: 0.7 }).addTo(pathMap.value);
  // polylineLayer.push(polyline);
};

import arrow0 from '@/assets/path_arrows/arrow_0.svg';
import arrow1 from '@/assets/path_arrows/arrow_1.svg';
import arrow2 from '@/assets/path_arrows/arrow_2.svg';
import arrow3 from '@/assets/path_arrows/arrow_3.svg';
import arrow4 from '@/assets/path_arrows/arrow_4.svg';
import arrow5 from '@/assets/path_arrows/arrow_5.svg';
import arrow6 from '@/assets/path_arrows/arrow_6.svg';
import arrow7 from '@/assets/path_arrows/arrow_7.svg';

const arrowImages = [
  arrow0,
  arrow1,
  arrow2,
  arrow3,
  arrow4,
  arrow5,
  arrow6,
  arrow7,
];
const drawArrowByDistance = (start, end) => {
  const map = pathMap.value;
  
  // 레이어 초기화
  if (polylineLayer.length) {
    polylineLayer.forEach(layer => map.removeLayer(layer));
    polylineLayer = [];
  }

  const distance = map.distance([start.lat, start.lng], [end.lat, end.lng]); // 미터(m)

  // 거리 기반으로 필요한 화살표 개수 계산 (최대 8개)
  const arrowCount = Math.min(8, Math.max(1, Math.floor(distance / 10))); // 50m당 1개 예시

  const latStep = (end.lat - start.lat) / arrowCount;
  const lngStep = (end.lng - start.lng) / arrowCount;

  for (let i = 0; i < arrowCount; i++) {
    const lat = parseFloat(start.lat) + latStep * (i + 0.5);
    const lng = parseFloat(start.lng) + lngStep * (i + 0.5);
    
    // 현재 화살표 색상 결정 (0~7 중에서)
    let imageIndex = Math.min(7, Math.floor((i / (arrowCount - 1)) * 7));
    if (!imageIndex) imageIndex = 0;

    // 방향 계산
    const angleRad = Math.atan2(start.lng - end.lng, start.lat - end.lat);
    const angleDeg = ((angleRad * 180) / Math.PI) - 3;

    const marker = L.marker([lat, lng], {
      icon: L.divIcon({
        className: '',
        html: `
          <img src="${arrowImages[imageIndex]}" style="
            width: 50px;
            height: 50px;
            transform: rotate(${angleDeg}deg);
            transform-origin: center center;
          " />
        `,
        iconSize: [50, 50],
        iconAnchor: [25, 25]
      })
    }).addTo(map);

    polylineLayer.push(marker);
  }

  // 전체 영역 fitBounds
  map.fitBounds([
    [start.lat, start.lng],
    [end.lat, end.lng]
  ], { padding: [20, 20] });
};


// 검색어에 따라 필터링된 목록을 반환
const search = ref("");
const filteredActiveList = computed(() => {
  const query = search.value.trim().toLowerCase(); // 공백 제거 & 소문자 변환

  return sortedActiveEERList.value.filter(eer =>
  eer.event_time.toLowerCase().includes(query) // ID로 검색
    || eer.device_name.toLowerCase().includes(query) // 이름으로 검색
    || eer.geofence_name.toLowerCase().includes(query) // 영역으로 검색
    || eer.action.toLowerCase().includes(query) // 진입/진출으로 검색
    || String(eer.state).toLowerCase().includes(query) // 유형으로 검색
  );
});
watch(search, () => {
  if (currentPage.value > totalPages.value) currentPage.value = totalPages.value;
  if (currentPage.value === 0) currentPage.value = 1;
});
</script>